const MAX_SHEET_NAME_LENGTH = 31;

/**
 * Truncates a string to maxLength, breaking at a separator boundary when possible.
 */
const truncateToLimit = (str: string, maxLength: number): string => {
    if (str.length <= maxLength) return str;
    const truncated = str.slice(0, maxLength);
    const lastSep = truncated.lastIndexOf(' - ');
    return lastSep > 0 ? truncated.slice(0, lastSep) : truncated;
};

/**
 * Gets the short name for a working unit, suitable for Excel sheet tabs (max 31 chars).
 * Handles both object-based ({ worktype: { worktype, shortName } }) and string-based ({ worktype, worktypeShortName }) structures.
 * The result is truncated to 31 characters to satisfy the Excel sheet name limit.
 */
export const getWorkingUnitShortName = (workingUnit: Record<string, any>): string => {
    if (workingUnit.shortName) {
        return workingUnit.shortName;
    }

    const getWorktypePart = () => {
        if (typeof workingUnit.worktype === 'object') {
            return workingUnit.worktype?.shortName || workingUnit.worktype?.worktype;
        }
        return workingUnit.worktypeShortName || workingUnit.worktype;
    };

    const getChannelPart = () => {
        if (typeof workingUnit.channel === 'object') {
            return workingUnit.channel?.shortName || workingUnit.channel?.name;
        }
        return workingUnit.channelShortName || workingUnit.channel;
    };

    const getTaskPart = () => {
        if (typeof workingUnit.task === 'object') {
            return workingUnit.task?.shortName || workingUnit.task?.name;
        }
        return workingUnit.taskShortName || workingUnit.task;
    };

    const parts = [getWorktypePart(), getChannelPart(), getTaskPart()].filter(Boolean);
    return truncateToLimit(parts.join(' - '), MAX_SHEET_NAME_LENGTH);
};
